import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PaypalService } from '../../_LOGIC/__paypal/paypal.service';
import { BookingService } from 'src/app/_LOGIC/booking.service';
  
declare var paypal;
@Component({
  selector: 'app-paypal-buttons',
  templateUrl: './paypal-buttons.component.html',
  styleUrls: ['./paypal-buttons.component.css']
})
export class PaypalButtonsComponent implements OnInit {

  /* Integration
  https://www.youtube.com/watch?v=AtZGoueL4Vs&ab_channel=Fireship
 */
  payeeEmail: string = '<Merchant Account to credit the charge Amount>';

  paidFor: boolean = false; //Payment Successful Message handling
  /* paypalConfig = {//Configuration for paypal Smart Button
  }; */
  product = {
    price: null,
    description: null
  }

  @ViewChild("paypal", { static: true }) paypalElement: ElementRef;

  constructor(private paypalService: PaypalService,private bookingService: BookingService) { }
 
  ngOnInit() {


    debugger;

    paypal.Buttons({
      createOrder: (data,actions) => {
        return actions.order.create({
          purchase_units: [
            {
              description: 'Manager To Owner Payment',
              amount: {
                currency_code: 'USD',
                value: this.getOrderTotal()
              }
            }
          ]
        });
      },
      onApprove: async(data,actions) => {
        const order = await actions.order.capture();
        this.paidFor = true;
        console.log(order);
      },
      onError: err => {
        debugger
        console.log(err);
      }
      
    }).render(this.paypalElement.nativeElement)
  }

  getOrderTotal(){
    return this.bookingService.getBookingTotal();
  }

  getOrderDetails(){}

}